import { render } from "./ChangeOwnerModal.vue?vue&type=template&id=92951f38&ts=true"
import script from "./ChangeOwnerModal.vue?vue&type=script&lang=ts"
export * from "./ChangeOwnerModal.vue?vue&type=script&lang=ts"

import "./ChangeOwnerModal.vue?vue&type=style&index=0&id=92951f38&lang=scss"

import exportComponent from "/home/jenkins/agent/workspace/git_node_build_images_push_anjinq_test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__